/**
 * THE app's sign-out, in one place.
 *
 * Before this there were two copies of `msalInstance.logoutRedirect(...)`
 * (AppShell's profile menu and SessionTimeoutWarning) and /join had a third
 * thing entirely: it navigated to `/?signout=1`, which nothing reads — so the
 * button said "Sign out and switch account" and did not sign anyone out.
 *
 * Returns whether a sign-out was actually started, so a caller can fall back
 * when there is no session to end: with AUTH_ENABLED=false there is no MSAL
 * session at all, and dev identities are switched with the dev switcher
 * rather than by signing out.
 */
import { isAuthEnabled } from '@/env';
import { msalInstance } from '@/lib/auth/msalConfig';

export function startSignOut(returnTo?: string): boolean {
  if (!isAuthEnabled()) return false;
  // No `returnTo` keeps the exact value the profile menu has always sent —
  // the bare origin — so this is a refactor there and not a behaviour change.
  const postLogoutRedirectUri = returnTo
    ? `${window.location.origin}${returnTo}`
    : window.location.origin;
  // Fire-and-forget: logoutRedirect navigates away, so there is nothing to
  // await and no state worth keeping.
  void msalInstance.logoutRedirect({ postLogoutRedirectUri });
  return true;
}
